<template>
  <div class="ty-main">
    <el-page-header @back="goBack" :content="name === null ? '未知员工' + '已分配离职成员资产' : name + '已分配离职成员资产'">
    </el-page-header>
    <!-- 已分配 -->
    <div class="ty-card">
      <div class="ty-tab">
        <div
          class="tab-item"
          v-for="(item, index) in tabs"
          :key="index"
          :class="{ active: tabIndex === index }"
          @click="tabChange(index)"
        >
          {{ item.title }}
          <span v-if="tabIndex === index">[{{ total || 0 }}人]</span>
        </div>
      </div>
    </div>
    <div class="ty-content white">
    <!--  <div class="mb20">
        <el-radio-group v-model="radio1">
          <el-radio-button label="customer">已分配客户 [{{ totalCustomer }}]</el-radio-button>
          <el-radio-button label="group">已分配群聊 [{{ totalGroup }}]</el-radio-button>
        </el-radio-group>
      </div> -->
      <el-table :data="customerData" style="width: 100%;" v-show="radio1 === 'customer'">
        <el-table-column prop="kehu_user" label="客户名称" fixed width="280">
        <template slot-scope="scope">
         <el-popover
            v-if="scope.row.name && scope.row.name.length > 10"
            placement="top-start"
            popper-class="popperBox"
            trigger="hover">
            <div>
              {{ scope.row.name }}
              <span
                v-if="scope.row.type === 2"
                style="color:#FF9C40"
                >@{{ scope.row.remarks.corp_name }}</span
              >
              <span v-else style="color:#09C160">@微信</span>
            </div>
            <span slot="reference" style="color: #303133;">
              <div style="display: flex;">
              <img :src="scope.row.avatar" style="width:40px;height:40px;margin-right: 5px;border: 1px solid rgba(32, 74, 158, 0.48);" />
                <div>
                  {{ scope.row.name | ellipsis}}
                  <span
                    v-if="scope.row.type === 2"
                    style="color:#FF9C40"
                    >@{{ scope.row.remarks.corp_name }}</span
                  >
                  <span v-else style="color:#09C160">@微信</span>
                </div>
              </div>
            </span>
          </el-popover>
          <div v-else style="display: flex;"><img :src="scope.row.avatar" style="width:40px;height:40px;margin-right: 5px;border: 1px solid rgba(32, 74, 158, 0.48);" />
          <span>{{scope.row.name}}</span><span
                    v-if="scope.row.type === 2"
                    style="color:#FF9C40"
                    >@{{ scope.row.remarks.corp_name }}</span
                  >
                  <span v-else style="color:#09C160">@微信</span></div>
          <span v-if="scope.row.name === null">未知员工</span>
          </template>
        </el-table-column>
        <el-table-column label="接替成员" width="300">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.staff_name && scope.row.staff_name.length > 10"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <div>{{scope.row.staff_name}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></div>
              <span slot="reference" style="color: #303133;">{{scope.row.staff_name | ellipsis}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
            </el-popover>
            <span v-else>{{scope.row.staff_name}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
            <span v-if="scope.row.staff_name === null">-</span>
          </template>
        </el-table-column>
        <el-table-column label="接替状态" min-width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.is_use !== ''" >
              <span v-if="scope.row.is_use === 1">已继承</span>
              <span v-else-if="scope.row.is_use === 2">未继承</span>
              <span v-else-if="scope.row.is_use === 3">接替中</span>
              <span v-else-if="scope.row.is_use === 4">已拒绝</span>
              <span v-else>接替已达上限</span>
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column label="接替成员所属部门" width="354">
          <template slot-scope="scope">
            <div v-if="scope.row.department_name.length > 0">
                <el-popover
                  v-if="scope.row.department_name.length > 20"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <div>{{scope.row.department_name}}</div>
                  <span slot="reference" style="color: #303133;">{{scope.row.department_name | ellipsiss}}</span>
                </el-popover>
                <span v-else>{{scope.row.department_name}}</span>
              </div>
              <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column prop="assign_time" label="分配时间" min-width="180">
           <template slot-scope="scope">
            <span>{{ scope.row.assign_time ? scope.row.assign_time : '-'}}</span>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty v-loading="loading"></el-empty>
        </template>
      </el-table>
      <el-table :data="groupData" style="width: 100%" v-show="radio1 === 'group'">
        <el-table-column label="群聊" fixed width="194">
          <template slot-scope="scope">
              <el-popover
                v-if="scope.row.group_name && scope.row.group_name.length > 10"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.group_name}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.group_name | ellipsis}}</span>
              </el-popover>
              <span v-else>{{scope.row.group_name ? scope.row.group_name : '-'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="number" label="群人数" min-width="180">
        </el-table-column>
        <el-table-column label="新群主" width="280">
           <template slot-scope="scope">
              <el-popover
                v-if="scope.row.name && scope.row.name.length > 10"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.name}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></div>
                <span slot="reference" style="color: #303133;">{{scope.row.name | ellipsis}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
              </el-popover>
              <span v-else>{{scope.row.name}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
              <span v-if="scope.row.name === null">未知员工</span>
            </template>
        </el-table-column>
        <el-table-column label="新群主所属部门" width="354">
          <template slot-scope="scope">
            <div v-if="scope.row.department_name.length > 0">
                <el-popover
                  v-if="scope.row.department_name.length > 20"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <div>{{scope.row.department_name}}</div>
                  <span slot="reference" style="color: #303133;">{{scope.row.department_name | ellipsiss}}</span>
                </el-popover>
                <span v-else>{{scope.row.department_name}}</span>
              </div>
              <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column prop="assign_time" label="分配时间" min-width="180"></el-table-column>
        <template #empty>
          <el-empty v-loading="loading01"></el-empty>
        </template>
      </el-table>
      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="radio1 === 'customer' ? customerPage : groupPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="radio1 === 'customer' ? totalCustomer : totalGroup"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: String
  },
  data() {
    return {
      tabs: [
        {
          title: '已分配客户'
        },
        {
          title: '已分配群聊'
        }
      ],
      customerPage: 1,
      groupPage: 1,
      pagesize: 10,
      type: 1,
      tabIndex: 0,
      total: 0,
      name: '',
      customerData: [],
      groupData: [],
      totalCustomer: 0,
      totalGroup: 0,
      dimissionUser: '',
      radio1: 'customer',
      loading: false,
      loading01: false,
      isDepartmentDialog: false
    //  allotOptions: ['接替完毕', '等待接替', '客户拒绝', '接替成员客户达到上限', '无接替记录']
    }
  },
  mounted() {
    this.getCustomer()
    // this.getList2()
  },
  methods: {
    getCustomer() {
      this.loading = true
      this.$api
        .get('/api/v1/inherit/allocation-details', {
          user_id: this.id,
          page: this.customerPage,
          type: this.type,
          is_use: 1
        })
        .then(res => {
          if (res) {
            this.totalCustomer = res.coutn
            this.customerData = res.list
            this.total = this.totalCustomer
            if (res.user && res.user.name !== '') {
              this.dimissionUser = res.user.name
            }
            this.loading = false
            this.name = res.tag_name
          }
          this.loading = false
        })
    },
    // 获取已继承列表
    getList2() {
      this.ischange = true
      const params = {
        page: this.currentPage
      }
      this.$api.get('/api/v1/inherit/be-succeeded', params).then( res => {
        const arr = res.list
        // arr.forEach(k => {
        //   if (this.id === k.staff_id) {
        //     this.name = k.name
        //   }
        // })
        this.ischange = false
      })
    },
    getGroup() {
      this.loading01 = true
      this.$api
        .get('/api/v1/inherit/allocation-qun-details', {
          user_id: this.id,
          page: this.groupPage,
          type: 2,
          is_use: 1,
          limit: 10
        })
        .then(response => {
            this.totalGroup = response.coutn
            this.groupData = response.list
            this.total = this.totalGroup
            this.loading01 = false
        })
    },
    currentChange(val) {
      if (this.radio1 === 'customer') {
        this.customerPage = val
        this.getCustomer()
      } else {
        this.groupPage = val
        this.getGroup()
      }
    },
    tabChange(index) {
      this.tabIndex = index
      if (this.tabIndex === 0) {
        this.radio1 = 'customer'
        this.type = 1
        this.getCustomer()
      } else {
        this.radio1 = 'group'
        this.type = 2
        this.getGroup()
      }
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
.ty-card {
  padding-bottom: 5px;
  border-radius: 2px;
}
.el-card {
  position: relative;
  height: 500px;
  overflow: auto;
  box-shadow: none;
}
.el-tag {
  margin: 0 10px 10px 0;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
 .ty-tab .tab-item.active{
  font-size: 18px;
  font-weight: 550;
}
::v-deep .ty-tab .tab-item {
  height: 33px;
  font-size: 16px;
  line-height: 36px;
  margin-bottom: 0;
  border-radius: 2px 2px 0px 0px;
}
::v-deep .tab-item:hover{
  color: #204A9E;
}
::v-deep .ty-tab .tab-item.active::after{
    content: "";
    position: absolute;
    top: 58px;
    left: 0;
    width: 100%;
    height: 3px;
    background: #204a9e;
    border-radius: 2px 2px 0px 0px;
}
</style>
